import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RemoteApiService } from 'src/app/shared/services/remote-api.service';
import { environment } from 'src/app/environments/environments';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AuthService } from 'src/app/features/services/auth/auth.service';

@Component({
  selector: 'app-invite-user-dialog',
  templateUrl: './invite-user-dialog.component.html',
  styleUrls: ['./invite-user-dialog.component.scss']
})
export class InviteUserDialogComponent {

  inviteForm: FormGroup;
  isLoading = false;
  isSent = false;
  isError = false;
  isRetrying = false;

  private emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  roles = [
    { value: 'manager', label: 'Manager', description: 'Same as Admin, except Advanced AI Settings, Manage Users and Plans', icon: 'supervisor_account' },
  //  { value: 'analyst', label: 'Analyst', description: 'Analytics only', icon: 'bar_chart' },
    { value: 'viewer', label: 'Viewer', description: 'Read only', icon: 'visibility' },
  ];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<InviteUserDialogComponent>,
    private RAS: RemoteApiService,
    private notificationService: NotificationService,
    private auth: AuthService
  ) {
    this.inviteForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      role: ['', Validators.required],
    });
  }

  get selectedRole() {
    return this.roles.find(r => r.value === this.inviteForm.get('role')?.value);
  }

  get isEmailValid(): boolean {
    const emailControl = this.inviteForm.get('email');
    return emailControl?.valid === true && emailControl?.value?.length > 0;
  }

  onSend() {
    this.inviteForm.markAllAsTouched();
    if (this.inviteForm.invalid) return;
    this.isLoading = true;
    this.isError = false;

    const { email, role } = this.inviteForm.value;

    const body = {
      email: email,
      role: role,
      userId: this.auth.getAccountUserId() || this.auth.getCurrentUser()?.id || ''
    }

    this.RAS.postApi(`${environment.userManagerUrl}createInvitedUser`, body)
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          if (res.success) {
            this.isSent = true;
          } else {
            this.isError = true;
          }
        },
        error: () => {
          this.isLoading = false;
          this.isError = true;
        }
      });
  }

  onRetry() {
    this.isError = false;
    this.isSent = false;
    this.isRetrying = false;
    this.isLoading = false;
  }

  onResend() {
    this.isSent = false;
    this.isError = false;
    this.isRetrying = false;
    this.inviteForm.reset({ role: 'admin' });
  }

  onClose() {
    this.dialogRef.close();
  }
}